export enum ContestStatus {
  Draft = 0,
  Active = 1,
  Upcoming = 2,
  Complete = 3,
}

export enum WeekStatus {
  Draft = 0,
  Active = 1,
  Upcoming = 2,
  Complete = 3,
}

export enum GameTypeEnum {
  PUBLIC = 0,
  PRIVATE = 1,
}
